import React from "react";

import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import Dialog from "@busbud/design-system-components/dist/Dialog";
import DialogTitle from "@busbud/design-system-components/dist/DialogTitle";

import type { ViewName } from "./views-manager/authentication-views-manager";
import type { Dispatch } from "@reduxjs/toolkit";

import { useStyles } from "./authentication.styles";
import { AuthenticationViewsManager } from "./views-manager";
import { closeModal } from "../../../modules/checkout/actions";

interface Props {
  onClose?: () => void;
  opening_view?: ViewName;
  redirect_url?: string;
  carousel_start_idx?: number;
  from_expired_link?: boolean;
}
interface ReduxProps {
  closeModal: () => void;
}

const AuthenticationComponent: React.FC<ReduxProps & Props> = ({
  closeModal,
  onClose,
  opening_view,
  redirect_url,
  carousel_start_idx,
  from_expired_link
}) => {
  const { classes } = useStyles();

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      classes={{ box: classes.dialog }}
      // tabIndex transition prop prevents autocomplete from some password manager extensions
      // https://github.com/ariakit/ariakit/issues/863
      TransitionProps={{ tabIndex: "none" }}
    >
      <DialogTitle
        classes={{ root: classes.title }}
        onClose={() => {
          onClose?.();
          closeModal();
        }}
      />
      <AuthenticationViewsManager
        opening_view={opening_view}
        redirect_url={redirect_url}
        carousel_start_idx={carousel_start_idx}
        from_expired_link={from_expired_link}
      />
    </Dialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({ closeModal }, dispatch);
};

const connector = connect(() => ({}), mapDispatchToProps);

export const Authentication = connector(AuthenticationComponent);
